export { NpsScoreScale } from "./NpsScoreScale"
export type { NpsScoreScaleProps } from "./NpsScoreScale"
